export class TaskInstructionType {
  static WORK = 'WorkInstructions';
  static SPARE = 'SpareInstructions';
}
